<template>
  <vs-popup v-if="userToEdit && userToEdit != null" :active="userToEdit && userToEdit != null"
            v-on:update:active="editChanged" :title="userToEdit.id > 0 ? $t('EditUserTitle') : $t('AddNewUserTitle')">
    <vs-popup :title="$t('UploadImageTitle')" :active.sync="inImageUpload">
      <vs-upload automatic :multiple="false" :action="DAMActionPath" @on-success="uploadSucceeded" :headers="GetUserHeaders()" />
    </vs-popup>
    <vs-tabs>
      <vs-tab :label="userToEdit.id != null ? $t('EditUserTitle') : $t('CreateUserTab')" icon-pack="feather" icon="icon-user-plus">
        <div class="vx-row">

          <div v-if="userToEdit.id != null" :style="'margin-right: 20px; position: relative;  float: left; width: 80px; height: 80px;'"
               onmousemove="this.classList.add('hover')"
               onmouseleave="this.classList.remove('hover')">
            <vs-avatar ref="avatar1"
                       :icon-pack="!HasPhoto() ? 'feather' : null"
                       :icon="!HasPhoto() ? 'icon-user' : null"
                       size="64px"
                       style="display: inline-block; float: left"
                       :src="userToEdit.avatarUrl" />
            <label class="custom-file-upload">
              <input class="avatar-hover"
                     style="display:none;"
                     type="file"
                     @change="successUpload"
                     ref="photoUpload" />
              <i class="fa fa-cloud-upload">...</i>
            </label>
          </div>

          <vs-input v-if="userToEdit.id == null" class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('EmailAddressLabel')"  v-model="email" />

          <vs-input  class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('FirstNameLabel')" v-model="userToEdit.firstName" />

          <vs-input class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('LastNameLabel')" v-model="userToEdit.lastName" />

          <vs-input v-if="userToEdit.id < 1" class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('EmailAddressLabel')"
                    v-model="userToEdit.email" />
        </div>
        <div class="vs-row">
          <div style="position: relative">
          </div>
          <vs-button v-if="userToEdit.id != null" color="success" type="gradient" icon-pack="feather" icon="icon-save" @click="save()" class="mb-3"
                     style="float:right; margin-top:20px;">{{ $t('SaveButton') }}</vs-button>

          <vs-button v-if="userToEdit.id == null" color="success" type="gradient" icon-pack="feather" icon="icon-save" @click="createUser()" class="mb-3"
                     style="float:right; margin-top:20px;">{{ $t('CreateUserButton') }}</vs-button>

        </div>
      </vs-tab>

      <vs-tab :label="userToEdit.id > 0 ? $t('EditUserTitle') : $t('AddUserToRoleTab')" icon-pack="feather" icon="icon-user-plus">
        <div style="min-height:600px;">
          <div class="vs-row">
            <div class="vx-col mt-3">
              <strong>{{ $t('ManageRoles') }}</strong>
            </div>
            <div class="vx-col mt-3">
              <div class="chip-container">

                <v-select multiple
                          label="name"
                          :closeOnSelect="false"
                          v-model="userToEdit.roles"
                          taggable
                          push-tags
                          :options="roles"
                          @option:created="CreateRole" />
              </div>
            </div>
          </div>
        </div>
      </vs-tab>

      <vs-tab :label="$t('ChangePasswordTab')" icon-pack="feather" icon="icon-mail" v-if="userToEdit.id > 0">
        <div v-if="userToEdit.id > 0">
          <vs-input class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('NewPasswordLabel')" type="password" v-model="password" />
          <vs-input class="vx-col w-1/3 lg:w-1/3" :label-placeholder="$t('ConfirmPasswordLabel')" type="password"
                    v-model="confirm" />
          <vs-button color="primary" type="filled" style="margin-top: 10px" @click="changePassword"
                     class="mb-3">{{ $t('ChangeButton') }}</vs-button>
        </div>
      </vs-tab>

      <vs-tab :label="$t('APIAccessTab')" icon-pack="feather" icon="icon-zap">
        <div class="vs-row">
          <div>
            <vs-input class="" style="width:100%;" readonly :label-placeholder="$t('APIKeyLabel')" :type="inputType" v-model="userToEdit.apiKey" />
          </div>

          <vs-button :class="{ 'disabled-class': !userToEdit.apiKey }"  :active.sync="userToEdit.apiKey" color="primary" type="filled" style="margin-top: 10px; float: right; margin-top: 20px;" @click="ResetAPIKey"
                     class="mb-3">{{ $t('ResetAPIKeyButton') }}</vs-button>

          <vs-button color="primary" type="filled" style="margin-top: 10px; margin-right: 20px; float: right; margin-top: 20px;" @click="GenerateAPIKey"
                     class="mb-3">{{ $t('GenerateNewButton') }}</vs-button>
        </div>
      </vs-tab>

      <vs-tab :label="$t('InviteUserTab')" icon-pack="feather" icon="icon-mail" v-if="userToEdit.id < 1">
        <div ref="inviteuser">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" type="email" :label-placeholder="$t('EmailAddressLabel')"
                    v-model="invitationEmail" />
          <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-user-plus" @click="invite"
                     class="mb-3" style="float:right; margin-top:20px;">{{ $t('InviteButton') }}</vs-button>
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>
<script>
  import RelatedItemsDropdown from "@/views/components/extra-components/RelatedItems/RelatedItemsDropdown.vue";
  import TagsService from "@/tags/tagsService.js";
  import AccountsService from "@/accounts/accountsService.js";
  import UploadScreen from "@/views/components/organisms/dam/UploadScreen.vue";
  import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';
  import vSelect from "vue-select";
  import FeatherIcon from "@/components/FeatherIcon.vue";

  export default {
    data() {
      return {
        roleId: null,
        email: null,
        roleRemoveId: null,
        roleInput: null,
        tempRoles: [],
        isActiveApiKey:false,
        roles: null,
        itemToEdit: null,
        tagsService: TagsService,
        selectedTags: [],
        password: null,
        inputType:"password",
        confirm: null,
        invitationEmail: '',
        inImageUpload: false,
        popupActive2: false,
        popupActive3: false,
        DAMActionPath: '',
        DAMDownloadPath: '',
        imageFile: null,         // Store the selected image file
        previewImage: null,      // Store the preview URL of the image
        uploadMessage: '',
        creatingRole: false,
      };
    },

    watch: {
      userToEdit(newValue, oldValue) {
        if (newValue != null) {
          this.loadRoles();
          if (localStorage.getItem("ApiKey") == this.userToEdit.apiKey) {
            this.isActiveApiKey = true
          }
          else {
            this.isActiveApiKey = false
            this.inputType = "password"
          }
        }
      },
      'userToEdit.roles': function (newRoles, oldRoles) {
        if (newRoles && oldRoles) {
          if (newRoles.length > oldRoles.length) {
            if (this.creatingRole != true) {
              this.addUserToRole(newRoles.filter(x => !oldRoles.includes(x)));
            }
          }
          else if (newRoles.length < oldRoles.length) {
            this.removeUserFromRole(oldRoles.filter(x => !newRoles.includes(x)));
          }
        }
      }
    },
    mounted() {
      this.DAMActionPath = TCVelikClient.BASE_ACCOUNT_URL + 'api/Dam/Upload';
      this.DAMDownloadPath = TCVelikClient.BASE_ACCOUNT_URL + 'api/Dam/Download';
    },
    methods: {
      HasPhoto() {
        return this.userToEdit && this.userToEdit.avatarUrl && this.userToEdit.avatarUrl.length > 0;
      },
      async successUpload(evt) {
        var file = evt.srcElement.files[0];
        if (file) {
          let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
          });

          this.$refs.avatar1.src = result_base64;
          this.uploadImage(result_base64, file.name);
          // this.CommitPhotoField(this.Contact, result_base64, this.FieldName);
        }
      },
      editChanged(val) {
        this.$emit("updated", val);
      },
      CreateRole(newRoleName) {
        var instance = this;
        instance.creatingRole = true;
        const query = `
                 mutation AddRole($roleName:String!) {
    addRole(roleName: $roleName, roleId: null) {
        id
        name
      }
}
                `;


        const variables = {
          roleName: newRoleName.name
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.creatingRole = false;
            instance.$vs.notify({
              title: instance.$t('AddedRole'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

            instance.userToEdit.roles[instance.userToEdit.roles.length - 1] = response.data.data.addRole
            var request = [response.data.data.addRole]

            instance.addUserToRole(request)
            instance.creatingRole = false;

          }
          else if (response && response.data && response.data.errors[0].message) {
            instance.creatingRole = false;
            instance.$vs.notify({
              title: instance.$t('RoleNameAlreadyExists'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            instance.creatingRole = false;
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },
      tagsUpdated(tags) {
        this.$set(this.userToEdit, "RelatedTags", tags);
      },
      loadRoles() {
        var instance = this;
        const query = `
                  query RolesWithUsers {
    rolesWithUsers {
        id
        name
        normalizedName
        concurrencyStamp
    }
}
                `;


        const req = {
          query
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.roles = response.data.data.rolesWithUsers;
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },

      addUserToRole(role) {
        var instance = this;
        const query = `
                  mutation AddUserToRole($roleId: String!, $userId: String!) {
                    addUserToRole(roleId: $roleId, userId: $userId) {
                        id
                        name
                    }
                }
                `;

        var variables = {
          userId: instance.userToEdit.id,
          roleId: role[0].id
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedChanges'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },

      removeUserFromRole(role) {

        var instance = this;
        var userId = instance.userToEdit.id
        const query = `
     mutation RemoveUserFromRole($roleId: String!, $userId: String!) {
       removeUserFromRole(roleId: $roleId, userId: $userId) {
           id
           name
       }
   }
   `;

        var variables = {
          userId: userId,
          roleId: role[0].id
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedChanges'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },


      //onFileChange(event) {
      //  const file = event.target.files[0];
      //  if (file && file.type.startsWith('image/')) {
      //    this.imageFile = file;
      //    this.previewImage = URL.createObjectURL(file);
      //    this.uploadMessage = '';  // Clear any previous messages
      //  } else {
      //    this.uploadMessage = 'Please select a valid image file.';
      //    this.imageFile = null;
      //    this.previewImage = null;
      //  }
      //},
      async uploadImage(base64Image, imageFileName) {
        var instance = this;
        TCVelikClient.PostRelative("/api/accounts/UploadAvatar", {
          FileName: imageFileName, FileData: base64Image, UserId: instance.userToEdit.id
        }).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.$t('ChangedAvatar'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingAvatar'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        })

      },
      fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(',')[1]); // Strip off metadata part
          reader.onerror = error => reject(error);
        });
      },

      save() {
        var instance = this;
        const query = `
                  mutation EditUser($editUserDTO:EditUserDTOInput!) {
                    editUser(editUserDTO: $editUserDTO){
                      avatarUrl
                        firstName
                        lastName
                        id
                        userName
                        normalizedUserName
                        email
                        normalizedEmail
                        emailConfirmed
                        passwordHash
                        securityStamp
                        concurrencyStamp
                        phoneNumber
                        phoneNumberConfirmed
                        twoFactorEnabled
                        lockoutEnd
                        lockoutEnabled
                        accessFailedCount,
                        provider
                    }
}
                `;

        var editUserDTO = {
          id: instance.userToEdit.id,
          firstName: instance.userToEdit.firstName,
          lastName: instance.userToEdit.lastName,
          provider: instance.userToEdit.provider == null ? "Default" : instance.userToEdit.provider,
          username: instance.userToEdit.userName,
          email: instance.userToEdit.email
        }

        var variables = {
          editUserDTO: editUserDTO
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SavedChanges'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ProblemsSavingChanges'));
          }
        });
      },
      invite() {
        var instance = this;
        this.$vs.loading({
          container: instance.$refs.inviteuser,
        });
        this.tempHidden = true;
        this.$emit("refresh", this);
        AccountsService.sendUserInvitation(this.invitationEmail).then(function (response) {
          if (response && response.data && response.data.Success) {
            instance.$vs.notify({
              time: 8000,
              title: instance.$t('Success'),
              text: instance.$t('UserInvited').replace('{email}', instance.invitationEmail),
              color: "success",
              iconPack: "feather",
              icon: "icon-success-circle",
            });

            instance.$set(instance, "invitationEmail", "");
            instance.$vs.loading.close(instance.$refs.inviteuser);
          }
        });
      },

      createUser() {
        var instance = this;
        TCVelikClient.PostRelative("/api/accounts/CreateGuestUser?email=" + instance.email + "&firstName=" + instance.userToEdit.firstName + "&lastName=" + instance.userToEdit.lastName).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.$t('SuccessfullyCreatedUser'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            setTimeout(() => { location.reload() }, 2000); 
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemCreatingUser'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      GenerateAPIKey() {
        var instance = this;
        if (confirm(instance.$t('GenerateAPIKeyConfirm'))) {
          TCVelikClient.PostRelative("/api/admin/GenerateAPIKey?userId=" + instance.userToEdit.id).then(function (response) {
            if (response && response.data) {
              instance.userToEdit.apiKey = response.data.ApiKey
              instance.inputType = "text"
              instance.$vs.notify({
                title: instance.$t('GeneratedAPIKey'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('ProblemGeneratingAPIKey'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
      },

      ResetAPIKey() {
        var instance = this;
        if (confirm(instance.$t('ResetAPIKeyConfirm'))) {
          TCVelikClient.PostRelative("/api/admin/ResetAPIKey?userId=" + instance.userToEdit.id).then(function (response) {
            if (response) {
              localStorage.removeItem("ApiKey")
              instance.userToEdit.apiKey = null
              instance.isActiveApiKey = false
              instance.$vs.notify({
                title: instance.$t('ResetAPIKey'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('ProblemResettingAPIKey'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
      },

      changePassword() {
        var instance = this;
        AccountsService.resetPassword(
          instance.userToEdit.Email,
          this.password,
          this.confirm,
          null,
          3
        ).then(function (response) {
          instance.$vs.notify({
            time: 8000,
            title: instance.$t('Success'),
            text: instance.$t('PasswordResetEmailSentUserEditor'),
            color: "success",
            iconPack: "feather",
            icon: "icon-success-circle",
          });
        });
      },
      GetUserHeaders() {
        var options = {};
        var extended = TCVelikClient.extendOptions(options);
        return extended.headers;
      },
      uploadSucceeded(evt) {
        var response = JSON.parse(evt.target.response);
        if (response && response.Results && response.Results.length > 0) {
          this.userToEdit.AvatarAsset = {
            Id: response.Results[0].Id
          };
        }
      }
    },
    props: ["userToEdit"],
    components: {
      RelatedItemsDropdown,
      UploadScreen,
      vSelect,
      FeatherIcon
    },
  };
</script>
<style scoped>
  * > > > .user-tags {
    padding-top: 10px;
  }

  .disabled-class {
    pointer-events: none;
    opacity: 0.5;
  }

  .custom-file-upload {
    position: absolute;
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    bottom: 0px;
    right: 0px;
    background: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }
</style>
